import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageFAQ} from '../components/page-faq';

export interface FAQPageProps {}

@inject(deps) @observer
export class FAQPage extends Component<FAQPageProps> {
  render() {
    return (
      <PageFAQ
        model={this.props.model.page.faq}
      />
    )
  }
}